import styled from "styled-components";

export const NextPrevLocationBaseWrapper = styled.div`
  width: 100%;
`;

export const NextPrevLocationContentWrapper = styled.div`
  width: 100%;
  padding: 8px;
  display: flex;
  .TreeSelectBaseWrapper {
    width: calc(100% - 56px);
    margin-right: 8px;
  }
`;

export const NextPrevLocationInfoWrapper = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 16px;
  }
`;

export const HeaderTitleWrapper = styled.div<{ $theme?: string }>`
  gap: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -6px;
`;

export const FloorPlanNextAndPrevWrapper = styled.div<{ $theme?: string }>`
  display: flex;
  display: flex;
  align-items: center;
`;

export const RenderIconWrapper = styled.div<{ $theme?: string, $isDisable?: boolean }>`
  opacity: ${props => props.$isDisable ? 0.5 : 1};
  .floor-plan-arrow-left,
  .floor-plan-arrow-right {
    cursor: ${props => props.$isDisable ? "not-allowed" : "pointer"};
  }
`;
